import React, { useEffect } from 'react';
import styled from 'styled-components';

import { icons } from '../..';


const adjustHeight = (textarea) => {
    if (textarea) {
        textarea.style.height = 'auto'; // Reset the height
        textarea.style.height = `${textarea.scrollHeight}px`; // Set it to the scrollHeight
    }
};

const TextAreaInput = ({ 
    title, 
    placeholder, 
    errorMessage,
    ready, 
    type, 
    bind, 
    setWidth,
    additionalStyling, 
    value, 
    onBlur, 
    typeOf, 
    maxChar,
    fromRight,
    symbol: Symbol,
    tabIndex,
    setAlign,
    inputRef,
    setTextAlign,
    onKeyDown,
    disabled,
    symbolRight: SymbolRight }) => {

    if (!onBlur) {
        onBlur = null;
    }

    if (!maxChar) {
        maxChar = null;
    }

    useEffect(() => {
        adjustHeight()
    }, [])

    const finalErrorMessage = errorMessage ? errorMessage : []

    return (

        <>
        <Container setAlign={setAlign} setWidth={setWidth} errorFormating={finalErrorMessage.length > 0}>

                {
                    !!Symbol && (
                        <ShowSymbol><Symbol /></ShowSymbol>
                    )
                }

                <InputComponent 
                    onInput={(e) => adjustHeight(e.target)}
                    setTextAlign={setTextAlign} 
                    additionalStyling={additionalStyling} 
                    onBlur={onBlur} 
                    fromRight={!!fromRight} 
                    symbol={!!Symbol} 
                    typeOf={typeOf} 
                    placeholder={placeholder} 
                    readOnly={!ready} 
                    type={type} 
                    tabIndex={tabIndex} 
                    onKeyDown={onKeyDown}
                    disabled={disabled}
                    {...(inputRef ? { ref: inputRef } : {})}
                    {...bind}
                />

                <CharCounter aboveMax={!!maxChar && (value ? (value.length > maxChar) : false)} >{(!!maxChar && (value ? (value.length > maxChar) : false)) ? `Exceeding maximum characters` : `` } { (value && !!maxChar) ? (value.length > 1 ? value.length : ``) : `` }{ !!maxChar ? ` / ${maxChar}` : ``} </CharCounter>
                
                {
                    !!SymbolRight || finalErrorMessage.length > 0 ? (
                        <ShowSymbolRight>
                           
                           { !!SymbolRight && <SymbolRight /> }
                           
                           { finalErrorMessage.length > 0 && <icons.ErrorSymbol /> }

                        </ShowSymbolRight>
                    ) : null
                }

        </Container>

        { finalErrorMessage.length > 0 ? (
            <ErrorFieldOuter>
                <ErrorField>

                    { 
                        finalErrorMessage.map((item) => (
                            <li>{ item }</li>
                        ))
                    }
    
                </ErrorField>
            </ErrorFieldOuter>
        ) : null }
        </>

    )

}

export default TextAreaInput;


const Container = styled.div`
    display:flex;
    justify-content:${props => !props.setAlign ? `flex-start` : props.setAlign};
    align-items:center;
    position:relative;
    border-radius:5px;
    outline:none;
    padding:10px;
    width:${props => !props.setWidth ? `100%` : props.setWidth};
    ${props => props.additionalStyling}
    ${props => props.errorFormating ? (`
        background: #FFF2F2;
        border: 1px solid #FF7F7F;
    `) : null }

`


const ErrorFieldOuter = styled.div`
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    width:100%;
`

const ErrorField = styled.div`
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    align-items:flex-start;
    width:100%;
    padding:10px;
    font-size:14px;
    border-bottom-left-radius:5px;
    border-bottom-right-radius:5px;
    list-style:none;

    & > li {
        color: red;
        margin-left:5px;

    }
`


const InputComponent = styled.textarea`
    width:100%;
    height:100%;
    border:none;
    outline:none;
    border-radius:5px;
    padding:5px;
    ${props => props.symbol ? `padding-left:50px` : null};
    text-align:${props=> !props.setTextAlign ? 'left' : props.setTextAlign};
    font-size:15px;
    z-index:1010;
    background:none;
    line-height: default;
    resize:none;
    ${props => props.additionalStyling}

    ${props => props.typeOf !== 'no-outline' ? (` 

    `
    
    ) : null}
   
`

const CharCounter = styled.div`
    position:absolute;
    right:20px;
    display:flex;
    align-items:center;
    justify-content:center;
    ${props => props.aboveMax ? `color: red` : null};
`

const ShowSymbol = styled.div`
    position:absolute;
    left:15px;
    display:flex;
    align-items:center;
    justify-content:center;
`

const ShowSymbolRight = styled.div`
    position:absolute;
    flex-direction:row;
    right:15px;
    display:flex;
    align-items:center;
    justify-content:center;
`